import GameStepBase from '../game_step_base';

// this class provides a base class (marker) for all classes that implements game opening
export default class LaunchGameStep extends GameStepBase {
    static CLASS = 'LaunchGameStep';

    run(gameOptions) {
        this.throwNotImplemented('8', 'run');
    }
}